/* eslint-disable jsx-a11y/no-static-element-interactions */
// Right now, this is not a very accessible component. The goal was to use the aria gridlist pattern with react-aria
// but it just is too buggy to be worth it.

import clsx from "clsx"
import type { KeyboardEvent, MouseEvent, ReactNode } from "react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../DropdownMenu"
import { Icon } from "../Icon"
import { IconButton } from "../IconButton"
import { Text } from "../Text"
import styles from "./SliceCard.module.css"

export interface SliceCardProps {
  id?: string
  title: string
  subTitle: string
  index: number
  children?: ReactNode
  menuItems?: ReactNode
  selected?: boolean
  canMove?: boolean
  onSelect?: (event: MouseEvent | KeyboardEvent) => void
}

export function SliceCard(props: SliceCardProps) {
  const {
    id,
    title,
    subTitle,
    index,
    children,
    menuItems,
    canMove = false,
    selected = false,
    onSelect,
  } = props

  const cardClass = clsx(
    styles.card,
    styles[`state-${selected ? "selected" : "normal"}`],
  )

  function onClick(event: MouseEvent) {
    onSelect?.(event)
  }

  function onKeyDown(event: KeyboardEvent) {
    if (event.code === "Enter" || event.code === "Space") onSelect?.(event)
  }

  return (
    <section id={id} className={styles.root}>
      <div
        className={cardClass}
        draggable={canMove}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        <div className={styles.outerContent}>
          <Text variant="smallBold" color="grey9">
            {index}
          </Text>
        </div>

        <div className={styles.main}>{children}</div>

        <div className={styles.outerContent}>
          {canMove && <Icon name="dragIndicator" color="grey8" size="small" />}
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.texts}>
          <Text variant="smallBold" color="grey11" noWrap>
            {title}
          </Text>
          <Text variant="small" color="grey11" noWrap>
            {subTitle}
          </Text>
        </div>

        {menuItems && (
          <DropdownMenu modal>
            <DropdownMenuTrigger>
              <IconButton icon="moreVert" size="small" />
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end">
              <DropdownMenuLabel>Slice options</DropdownMenuLabel>
              {menuItems}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </section>
  )
}
